// import { Lookup } from './lookup.interface';
import {
  MartialStatusLookup as CommonMaritalStatusLookup,
  MaritalStatuses as CommonMaritalStatuses,
} from '@govalta-emu/alss-common';

export interface MartialStatusLookup extends CommonMaritalStatusLookup {
  edbId?: string;
  lmtaDisplayValue?: string;
  financialLabel?: string;
  spouseLabel?: string;
}

//Copy of the common marital statuses but include edbId and lmtaDisplayValue fields
export const MaritalStatuses: { [name: string]: MartialStatusLookup } = {
  single: { ...CommonMaritalStatuses.single, edbId: '5', lmtaDisplayValue: 'Single' },
  married: { ...CommonMaritalStatuses.married, edbId: '3', lmtaDisplayValue: 'Married or equivalent' },
  commonLaw: { ...CommonMaritalStatuses.commonLaw, edbId: '4', lmtaDisplayValue: 'Married or equivalent' },
  separated: { ...CommonMaritalStatuses.separated, edbId: '6', lmtaDisplayValue: 'Single' },
  divorced: { ...CommonMaritalStatuses.divorced, edbId: '2', lmtaDisplayValue: 'Single' },
  widowed: { ...CommonMaritalStatuses.widowed, edbId: '7', lmtaDisplayValue: 'Single' },
};

// interdependence was not wanted for the aish appliation
export const MaritalStatusWithInterdependence: { [name: string]: MartialStatusLookup } = {
  ...MaritalStatuses,
  interdependent: {
    displayValue: 'Relation of interdependence',
    lmtaDisplayValue: 'Married or equivalent',
    code: 'interdependent',
    hasSpouseOrPartner: true,
    label: 'Interdependent',
  },
};

// TODO: This is now the same as the common MaritalStatus, so we should maybe just use the original list now.
export const IesMaritalStatuses: { [name: string]: MartialStatusLookup } = {
  ...MaritalStatuses,
  // commonLaw: {
  //   ...MaritalStatuses.commonLaw,
  //   displayValue: 'Partner',
  // },
};

// FB - reason for differences: Had changed to partner before other applications.
// Business requirements also required an 'unknown' because marital status may be unknown for someone filling out for deceased.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { commonLaw, ...fbMaritalStatus } = MaritalStatuses;
export const FbMaritalStatuses: { [name: string]: MartialStatusLookup } = {
  ...fbMaritalStatus,
  partner: {
    displayValue: 'Partner',
    code: 'partner',
    label: 'Partner',
    hasSpouseOrPartner: true,
    financialLabel: 'Partner financials',
  },
  married: {
    ...MaritalStatuses.married,
    financialLabel: 'Spouse financials',
  },
  unknown: {
    displayValue: `Unknown`,
    code: 'unknown',
  },
};
